import React, { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { TriangleAlert } from "lucide-react";

// IDLE SIGN-OUT WARNING — 2-minute countdown before the 30-minute idle session
// lock signs the terminal out. Any activity (or the button) keeps the session
// alive; this renders on every page since it lives beside the router.
const IDLE_LIMIT_MS = 30 * 60 * 1000;
const WARN_AT_MS = IDLE_LIMIT_MS - 2 * 60 * 1000;

export default function IdleWarning() {
  const { user, lastActivityRef, keepAlive } = useAuth();
  const [remaining, setRemaining] = useState(null); // seconds left, null = hidden

  useEffect(() => {
    if (!user) { setRemaining(null); return; }
    const iv = setInterval(() => {
      const idle = Date.now() - (lastActivityRef?.current || Date.now());
      setRemaining(idle >= WARN_AT_MS && idle < IDLE_LIMIT_MS
        ? Math.max(0, Math.ceil((IDLE_LIMIT_MS - idle) / 1000)) : null);
    }, 1000);
    return () => clearInterval(iv);
  }, [user, lastActivityRef]);

  if (!user || remaining === null) return null;
  const mm = String(Math.floor(remaining / 60)).padStart(1, "0");
  const ss = String(remaining % 60).padStart(2, "0");
  return (
    <div data-testid="idle-warning-banner"
      className="fixed top-0 inset-x-0 z-[2000] flex items-center justify-center gap-4 px-4 py-3 border-b-2"
      style={{ background: "#3a2408", borderColor: "#F59E0B" }}>
      <TriangleAlert size={20} className="animate-pulse shrink-0" style={{ color: "#F59E0B" }} />
      <div className="font-head font-bold text-sm text-white">
        INACTIVITY SIGN-OUT IN <span data-testid="idle-countdown" className="font-mono text-[#F59E0B]">{mm}:{ss}</span>
        <span className="font-mono font-normal text-[10px] text-[#D1D5DB] ml-2 hidden sm:inline">No activity detected for 28 minutes — security policy signs idle terminals out at 30.</span>
      </div>
      <button data-testid="idle-stay-signed-in" onClick={keepAlive}
        className="px-4 py-2 rounded-sm font-head font-bold text-xs text-black animate-pulse"
        style={{ background: "#F59E0B" }}>
        STAY SIGNED IN
      </button>
    </div>
  );
}
